import {
  ACTIVO_DESCUENTOS,
  CLEAR_ALL,
  GETALL_DESCUENTOS,
  LOADING_GETALL_DESCUENTOS,
  PARAMS_DESCUENTOS,
  SET_LOGOUT,
} from '../../../store/Types';

const initialState = {
  all: [],
  activo: null,
  loadingGetAll: false,
  params: {},
};

export const descuentosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_DESCUENTOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_DESCUENTOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_DESCUENTOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_DESCUENTOS:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
